import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER, formatQueryParams } from '../../utils';

export const getContentPagePath = ({ slug, source }) => {
    const params = { article_id: slug };
    return pathfinder(PATHFINDER.CONTENT_PAGE, params, formatQueryParams({ source }));
};
